/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Supported widget card widths.
 */
export enum ReportWidgetSize {
    HALF = 'half',
    FULL = 'full',
}
